// Messages between /lp/* landers and the /lp-cart iframe. The lander runtime
// bundles this file too, so keep it dependency-free.

export const LANDER_CART_PATH = '/lp-cart';

const MESSAGE_PREFIX = 'seed-lander-cart:';

export const LANDER_CART_MESSAGE = {
  OPEN: `${MESSAGE_PREFIX}open`,
  READY: `${MESSAGE_PREFIX}ready`,
  STATE: `${MESSAGE_PREFIX}state`,
  UNAVAILABLE: `${MESSAGE_PREFIX}unavailable`,
} as const;

export type LanderCartOpenRequest = {
  skus: string[];
  promoCode?: string;
};

export type LanderCartMessage =
  | ({ type: typeof LANDER_CART_MESSAGE.OPEN } & LanderCartOpenRequest)
  | { type: typeof LANDER_CART_MESSAGE.READY }
  | { type: typeof LANDER_CART_MESSAGE.STATE; open: boolean }
  | { type: typeof LANDER_CART_MESSAGE.UNAVAILABLE };

export const isLanderCartMessage = (
  data: unknown,
): data is LanderCartMessage => {
  const type = (data as { type?: unknown } | null)?.type;
  return typeof type === 'string' && type.startsWith(MESSAGE_PREFIX);
};
